import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { AlertToastService } from '@service/alert-toast.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private alertService: AlertToastService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let tokenReq: any;
    const token: any = this.authService.getToken();
    if (token) {
      tokenReq = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`, 'Cache-Control': 'no-cache',
        }
      });
    }
    else {
      if (request.headers.has('authorization')) {
        let token: string = request.headers.get('authorization')!
        tokenReq = request.clone({
          setHeaders: {
            Authorization: token, 'Cache-Control': 'no-cache',
          }
        });
      } else {
        tokenReq = request.clone({
          setHeaders: {
            Authorization: `Basic cGlja3JpZ2h0LWlkOnBpY2tyaWdodC1zZWNyZXQ=`, 'Cache-Control': 'no-cache',
          }
        });
      }
    }

    return next.handle(tokenReq).pipe(
      map((event) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.showError(error);
        return throwError(error);
      })
    );
  }

  private showError(err: HttpErrorResponse) {
    if (err.status === 401 || err.status === 403) {
      this.alertService.show({ message: 'Session Expired', type: 'danger' })
      this.router.navigate(['/'])
      this.authService.logout()
      return;
    }
    if (err.status === 504) {
      this.alertService.show({ message: 'No internet connection. Please Try Again.', type: 'danger' })
      return;
    }

    // return an observable with a user-facing error message
    let errString = '';
    if (err && err.error && err.error.message) {
      if (err.error.message.constructor === Array) {
        for (var i = 0; i < err.error.message.length; i++) {
          if (i < err.error.message.length) {
            errString += err.error.message[i].errorMessage + '\r\n';
          }
        }
      } else if (err.error.message.constructor === Object) {
        errString = err.error.message.errorMessage;
      }
      else {
        errString = err.error.message;
      }
    }
    else if (err && err.error && err.error.error && err.error.error.message) {
      if (err.error.error.message.constructor === Array) {
        for (var i = 0; i < err.error.error.message.length; i++) {
          if (i < err.error.error.message.length) {
            errString += err.error.error.message[i].errorMessage + '\r\n';
          }
        }
      } else if (err.error.error.message.constructor === Object) {
        errString = err.error.message.errorMessage;
      }
      else {
        errString = err.error.error.message;
      }
    }
    this.alertService.show({ message: errString || 'Somethig went wrong. Please Try Again.', type: 'danger' })
    return;
  }
}
